import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingOverlay } from "../components/LoadingOverlay";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:30801";
const NAVY = "#1e3a8a";
const TEAL = "#00c9a7";

export default function SetupLinkPage() {
  const { token } = useParams<{ token: string }>();
  const [email, setEmail]   = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!token) { setError("No token provided."); return; }
    setLoading(true); setError("");
    try {
      const r = await fetch(`${API_URL}/api/auth/setup/validate`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, email: email.trim().toLowerCase() }),
      });
      const d = await r.json();
      if (!r.ok) {
        setError(d.detail || "This setup link is invalid or has expired.");
      } else {
        window.location.href = "/security";
      }
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: `linear-gradient(135deg, ${NAVY} 0%, #0f172a 100%)`,
      fontFamily: "var(--font-sans)",
    }}>
      <LoadingOverlay active={loading} />
      <div style={{
        background: "white", borderRadius: 16, padding: "48px 40px",
        width: "min(400px, calc(100vw - 32px))", textAlign: "center",
        boxShadow: "0 25px 50px rgba(0,0,0,0.3)",
      }}>
        <img src="/favicon.png" alt="HRxAI" style={{
          width: 64, height: 64, borderRadius: 14, objectFit: "contain",
          margin: "0 auto 20px", display: "block",
        }} />

        <h1 style={{ color: NAVY, fontSize: 22, fontWeight: 800, margin: "0 0 4px" }}>
          HRx<span style={{ color: TEAL }}>AI</span>
        </h1>

        <div style={{ fontSize: 36, margin: "20px 0 12px" }}>🔐</div>
        <h2 style={{ color: NAVY, margin: "0 0 8px", fontSize: 18 }}>Confirm your identity</h2>
        <p style={{ color: "#64748b", fontSize: 13, margin: "0 0 24px", lineHeight: 1.5 }}>
          Enter the email address this setup link was sent to.
        </p>

        {error && (
          <div style={{
            background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8,
            padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#dc2626",
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
          <input
            type="email"
            autoFocus
            required
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{
              width: "100%", padding: "11px 14px", borderRadius: 10, fontSize: 14,
              border: "1.5px solid #e2e8f0", outline: "none", boxSizing: "border-box",
              color: "#1e293b", marginBottom: 14,
            }}
          />
          <button
            type="submit"
            disabled={!email || loading}
            style={{
              width: "100%", padding: "13px 0", borderRadius: 10, border: "none",
              background: !email || loading ? "#94a3b8" : `linear-gradient(135deg, ${NAVY}, ${TEAL})`,
              color: "white", fontSize: 15, fontWeight: 700,
              cursor: !email || loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Verifying…" : "Confirm & Set Up Account →"}
          </button>
        </form>

        <a href="/login" style={{ display: "block", marginTop: 20, color: "#94a3b8", fontSize: 13, textDecoration: "none" }}>
          ← Back to login
        </a>
      </div>
    </div>
  );
}
